module.exports = __webpack_public_path__ + "static/inputerfassungzielerreichung-a926f54cbe5903d53f90780b49b81253.jpg";